<template>
  <div class="background_enterprise">
    <div class="enterprise_index_text">
      <p style="font-size: 24px;margin-bottom: 1vh" class="animate__fadeInUp animate__animated">Portfolio</p>
      <p style="font-size: 32px; margin-bottom: 5vh;line-height: 40px" class="animate__fadeInUp animate__animated animate__delay-1s">
        Having obtained ownership interests in over 350 portfolio
        companies and accompanied them through full industry cycles for the past 15 years, SIG has accumulated deep
        insights and extensive knowledge in various industries.</p>
      <p class="animate__fadeInUp animate__animated animate__delay-2s">SIG’s portfolio companies share experiences and
        resources in operation/strategy/hiring, and build business
        synergies together. Moreover, as an investor throughout Asia, we are able
        to see the trends, understand the strengths and needs in each country and are able to assist our portfolio
        companies in identifying and taking advantage of their regional opportunities.</p>
      <p class="animate__fadeInUp animate__animated animate__delay-2s">We invest with SIG’s internal capital which means
        we have no duration limits and have no outside limited
        partners. Therefore, SIG has its natural advantage to exercise an
        independent investment philosophy and make fast and flexible investment decisions, which helps our portfolio
        companies to concentrate on their business growth.</p>
      <div style="padding-top: 2vh" class="animate__fadeInUp animate__animated animate__delay-3s">
        <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Enterprise_index_en",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 90 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.enterprise_index_text {
  padding-top: 20vh;
  text-align: left;
  margin-left: 12vw;
  margin-right: 12vw;
}

.background_enterprise {
  background-image: url("../../../assets/background/enterprise_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}

.enterprise_index_text p {
  font-size: 16px;
}
</style>